import { TILE_SIZE, TILE_SIZE_PX } from "../../constants";
import { Images } from "../../lib/images";
/**
 * 2D array of tiles.
 */
export class TileLayer {
    constructor(w, h) {
        this.tiles = [];
        this.w = 0;
        this.h = 0;
        // Index of the top left corner of this level. Can move when the level grows.
        this.x = 0;
        this.y = 0;
        this.animCount = 0;
        this.w = w;
        this.h = h;
        // Fill with the zero value.
        for (let y = 0; y < this.h; y++) {
            this.tiles[y] = [];
            for (let x = 0; x < this.w; x++) {
                this.tiles[y][x] = 0;
            }
        }
    }
    update(dt) {
        this.animCount += dt;
    }
    render(context, level) {
        if (!this.image) {
            const imageInfo = Images.images["tiles"];
            if (!imageInfo.loaded) {
                return;
            }
            this.image = imageInfo.image;
        }
        const invMatrix = context.getTransform().inverse();
        const gameMinPoint = invMatrix.transformPoint({ x: 0, y: 0 });
        const gameMaxPoint = invMatrix.transformPoint({
            x: context.canvas.width,
            y: context.canvas.height,
        });
        const minXTile = Math.floor(gameMinPoint.x / TILE_SIZE);
        const minYTile = Math.floor(gameMinPoint.y / TILE_SIZE);
        const maxXTile = Math.floor(gameMaxPoint.x / TILE_SIZE);
        const maxYTile = Math.floor(gameMaxPoint.y / TILE_SIZE);
        for (let y = minYTile; y <= maxYTile; y++) {
            for (let x = minXTile; x <= maxXTile; x++) {
                this.renderTile(context, { x, y }, level);
            }
        }
    }
    renderTile(context, pos, level) {
        // Logic handled per layer.
    }
    drawTile(context, { tilePos, renderPos, }) {
        // Image must be loaded when this is called.
        context.drawImage(this.image, tilePos.x * TILE_SIZE_PX, tilePos.y * TILE_SIZE_PX, TILE_SIZE_PX, TILE_SIZE_PX, renderPos.x, renderPos.y, 
        // +1 is a kludge to avoid gaps between tiles.
        TILE_SIZE + 1, TILE_SIZE + 1);
    }
    drawQuarterTile(context, { tilePos, subTilePos, renderPos, }) {
        // Image must be loaded when this is called.
        const halfTileSizePx = TILE_SIZE_PX / 2;
        const halfTileSize = TILE_SIZE / 2;
        context.drawImage(this.image, tilePos.x * TILE_SIZE_PX + subTilePos.x * halfTileSizePx, tilePos.y * TILE_SIZE_PX + subTilePos.y * halfTileSizePx, halfTileSizePx, halfTileSizePx, renderPos.x + subTilePos.x * halfTileSize, renderPos.y + subTilePos.y * halfTileSize, 
        // +1 is a kludge to avoid gaps between tiles.
        halfTileSize + 1, halfTileSize + 1);
    }
    setTile(p, tile, { allowGrow = true } = {}) {
        // If out of bounds, extend the board!
        let y = p.y;
        while (allowGrow && y + this.y < 1) {
            this.tiles.unshift(this.tiles[0].slice());
            this.y++;
            this.h++;
        }
        while (allowGrow && y + this.y >= this.h - 1) {
            this.tiles.push(this.tiles[this.h - 1].slice());
            this.h++;
        }
        let x = p.x;
        while (allowGrow && x + this.x < 1) {
            for (let y = 0; y < this.h; y++) {
                this.tiles[y].unshift(this.tiles[y][0]);
            }
            this.x++;
            this.w++;
        }
        while (allowGrow && x + this.x >= this.w - 1) {
            for (let y = 0; y < this.h; y++) {
                this.tiles[y].push(this.tiles[y][this.w - 1]);
            }
            this.w++;
        }
        // Check if we're out of bounds, for when allowGrow is false.
        if (p.x + this.x < 0 || p.y + this.y < 0 || p.x + this.x >= this.w || p.y + this.y >= this.h) {
            throw new Error(`Tile out of bounds: ${p.x}, ${p.y}`);
        }
        this.tiles[p.y + this.y][p.x + this.x] = tile;
    }
    setTileAtCoord(p, tile, { allowGrow = true } = {}) {
        this.setTile({
            x: Math.floor(p.x / TILE_SIZE),
            y: Math.floor(p.y / TILE_SIZE),
        }, tile, { allowGrow });
    }
    getTile(p) {
        let x = Math.min(Math.max(p.x + this.x, 0), this.w - 1);
        let y = Math.min(Math.max(p.y + this.y, 0), this.h - 1);
        return this.tiles[y][x];
    }
    getTileAtCoord(p) {
        return this.getTile({
            x: Math.floor(p.x / TILE_SIZE),
            y: Math.floor(p.y / TILE_SIZE),
        });
    }
    get minX() {
        return this.x;
    }
    get minY() {
        return this.y;
    }
    get maxX() {
        return this.x + this.w - 1;
    }
    get maxY() {
        return this.y + this.h - 1;
    }
}
